import { SecondLevelHeader } from "@/components/SecondLevelHeader";
import { t } from "@repo/translation";

import type { CalendarView } from "../types";

export const CalendarSecondLevelHeader = ({
  activeTabPanelId,
  onClick,
}: {
  activeTabPanelId: CalendarView;
  onClick: (id: CalendarView) => void;
}) => (
  <SecondLevelHeader
    activeTabPanelId={activeTabPanelId}
    onClick={onClick}
    tabs={[
      {
        label: t("label.agenda"),
        tabPanelId: "AGENDA",
      },
      {
        label: t("label.overview"),
        tabPanelId: "OVERVIEW",
      },
      {
        label: t("label.team"),
        tabPanelId: "TEAM",
      },
    ]}
    line
  />
);
